module.exports = __webpack_public_path__ + "img/customer1.92a125ad.png";